import React from "react";
import { Link } from "react-router-dom";

export const contactSections = [
  {
    type: "contact-hero",
    title:
      "Contact Chiller Fleet Transport — Book a Refrigerated Truck or Van Across Dubai & UAE",
    paragraphs: [
      <>Reach out to our dispatch team to rent <Link to="/services" className="internal-link">chiller vans, freezer vans</Link>, chiller and freezer trucks, or refrigerated trucks across Dubai and Sharjah. We've been handling <Link to="/services" className="internal-link">cold chain bookings</Link> since 2013, and our team typically responds within a few hours. Whether it's a same-day requirement or a scheduled run, contact us and we'll confirm vehicle availability for your route.</>,
    ],
  },

  { type: "contact-methods" },

  { type: "contact-info" },
];
